export default __webpack_public_path__ + "static/media/kitchen5-afterD-1024w.1defcc6f.png";